import { render, staticRenderFns } from "./popup-brief.vue?vue&type=template&id=82758f28&"
import script from "./popup-brief.vue?vue&type=script&lang=js&"
export * from "./popup-brief.vue?vue&type=script&lang=js&"
import style0 from "./popup-brief.vue?vue&type=style&index=0&id=82758f28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports